import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

export const ExplorerSearchActivities: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/activity/list/{transactionTypeCode}/{page}`
  ),
};

export const ExplorerSearchLocations: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/location/list/{transactionTypeCode}`
  ),
};

export const ExplorerSearchOrganisations: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/organisation/list`),
};

export const ExplorerSearchSectors: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/sector/list/{transactionTypeCode}`
  ),
};

export const ExplorerFeaturedFilters: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/general/featured-filters`),
};
